
import React from "react";
import { cn } from "@/lib/utils";
import { Progress } from "@/components/ui/progress";

interface OnboardingProgressBarProps {
  currentStep: number;
  totalSteps: number;
  className?: string;
}

const OnboardingProgressBar: React.FC<OnboardingProgressBarProps> = ({
  currentStep,
  totalSteps,
  className
}) => {
  const steps = [
    { number: 1, label: "Your Info" },
    { number: 2, label: "Location & Preferences" },
    { number: 3, label: "Connect What Matters" },
    { number: 4, label: "Add Your First Person" }
  ];

  // Adjust for the philosophy screen (step 0)
  const adjustedCurrentStep = currentStep - 1;
  const adjustedTotalSteps = totalSteps - 1;
  const progressPercentage = adjustedCurrentStep <= 0 ? 0 : ((adjustedCurrentStep - 1) / (adjustedTotalSteps - 1)) * 100;
  
  return (
    <div className={cn("w-full mb-6", className)}>
      <div className="flex justify-between mb-2">
        {steps.map((step) => (
          <div 
            key={step.number} 
            className={cn(
              "text-xs font-medium transition-colors",
              currentStep >= step.number ? "text-[#6C4F77]" : "text-gray-400"
            )}
          >
            Step {step.number}: {step.label}
          </div>
        ))}
      </div>
      <Progress 
        value={progressPercentage} 
        className="h-2 bg-[#E5DDE8] rounded-full"
        indicatorClassName="bg-[#6C4F77] rounded-full"
      />
    </div>
  );
};

export default OnboardingProgressBar;
